// PR-12.4 — pure helpers for the multi-invite flow.
// Kept in src/lib (not in components) so tests can import without
// pulling in the supabase client (jsdom errors on session load).

/**
 * Parses team-member-side invite-input into a clean list of unique email
 * addresses. Accepts: one-per-line, comma-separated, semicolon-separated,
 * or any mix. Trims whitespace, lowercases for dedupe, validates with a
 * lightweight RFC 5322 regex (server-side validation enforced by the
 * team_invitations.invited_email column).
 *
 * Used by AdminTeams' invite dialog. Exported as its own module so
 * unit tests don't need to mount the full component module.
 */
export function parseEmailList(raw: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const candidate of raw
    .split(/[\n,;]/)
    .map((s) => s.trim())
    .filter(Boolean)) {
    const lower = candidate.toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lower)) continue;
    if (seen.has(lower)) continue;
    seen.add(lower);
    out.push(lower);
  }
  return out;
}
